import * as MixpanelProfilePageActions from '@analytics/mixpanel/actions/ProfilePage';
import useWindowWidth from '@hooks/useWindowWidth';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { I18N_PROFILE_CONTEXT, READ_MORE, SEE_LESS } from '../ProfileForm.constants';
import { ProfileFormDescriptionSubText, ProfileFormDescriptionText } from './ProfileFormDescription.styles';
import { ProfileFormDescriptionProps } from './ProfileFormDescription.types';

const ProfileFormDescription = ({ children }: ProfileFormDescriptionProps): JSX.Element => {
  const router = useRouter();
  const windowWidth = useWindowWidth();
  const textRef = useRef<HTMLSpanElement>(null);
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [shouldExpand, setShouldExpand] = useState<boolean>(false);

  useEffect(() => {
    const setExpansionState = async () => {
      if (!textRef.current || windowWidth === 0) return;
      await setIsExpanded(true);
      const height = textRef.current?.getBoundingClientRect().height;
      setIsExpanded(false);
      if (height / 24 > 2) {
        setShouldExpand(true);
      } else {
        setShouldExpand(false);
      }
    };
    setExpansionState();
  }, [windowWidth, textRef, children]);

  const handleClick = () => {
    isExpanded ? MixpanelProfilePageActions.onCelebBioCollapsed({ router }) : MixpanelProfilePageActions.onCelebBioExpanded({ router });
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <ProfileFormDescriptionText ref={textRef} isExpanded={isExpanded}>
        {children}
      </ProfileFormDescriptionText>
      {shouldExpand && (
        <ProfileFormDescriptionSubText onClick={handleClick}>{isExpanded ? t(SEE_LESS) : t(READ_MORE)}</ProfileFormDescriptionSubText>
      )}
    </>
  );
};

export default ProfileFormDescription;
